import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { putLayoutName } from 'api/layout.service';
import { notificationActions } from 'redux/notification/notification.slice';
import { LayoutNameEntry } from 'types/entity';

export const LAYOUT_NAME_UPDATE_STORE_NAME = 'layoutNameUpdate';

export const updateLayoutName = createAsyncThunk(
  `${LAYOUT_NAME_UPDATE_STORE_NAME}/update`,
  async (payload: { projectId: string, layoutId: string, layoutNameEntry: LayoutNameEntry }, thunkAPI) => {
    const { projectId, layoutId, layoutNameEntry } = payload;
    await putLayoutName(projectId, layoutId, layoutNameEntry);
    thunkAPI.dispatch(notificationActions.addSuccess({ messageId: 'notification.layoutNameUpdate.success' }));
  },
);

export interface LayoutNameUpdateState {
  processing: boolean
  succeeded: boolean
  error: any
}

export const initialLayoutNameUpdateState: LayoutNameUpdateState = {
  processing: false,
  succeeded: false,
  error: null,
};

export const layoutNameUpdateSlice = createSlice({
  name: LAYOUT_NAME_UPDATE_STORE_NAME,
  initialState: initialLayoutNameUpdateState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateLayoutName.pending, (state) => {
      state.processing = true;
    });
    builder.addCase(updateLayoutName.fulfilled, (state) => {
      state.processing = false;
      state.succeeded = true;
    });
    builder.addCase(updateLayoutName.rejected, (state, action) => {
      state.error = action.payload;
      state.processing = false;
    });
  },
});

export const layoutNameUpdateActions = {
  ...layoutNameUpdateSlice.actions,
  updateLayoutName,
};

export default layoutNameUpdateSlice.reducer;
